import { useQuery } from "react-query";
import { QUERY_KEY_DATA_DASHBOARD } from "./keys";
import { api_get_new_dashboard_data, getAllUser } from ".";

export const useQueryDataDashboard = () => {
    const { data, isLoading, isFetching } = useQuery(
        QUERY_KEY_DATA_DASHBOARD,
        () => api_get_new_dashboard_data(),
        {
            refetchOnWindowFocus: true,
        }
    );

    return {
        data,
        isLoading,
        isFetching,
    };
};

export const useQuerySearchEmployee = ({ users, onSuccess }) => {
    const {
        data: all_users,
        isLoading,
        isFetching,
    } = useQuery(
        ["getAllUser", users],
        () => {
            return getAllUser(users);
        },
        {
            enabled: users !== "",
            refetchOnWindowFocus: false,
            onSuccess,
        }
    );

    return {
        all_users,
        isLoading,
        isFetching,
    };
};
